import Model from './Model'
import Comment from '@/models/Comment'

export default class Blog extends Model {
  resource() {
    return 'blogs'
  }

  comments() {
    return this.hasMany(Comment)
  }
}
